import { render, staticRenderFns } from "./kependudukan.vue?vue&type=template&id=02ac4376&"
import script from "./kependudukan.vue?vue&type=script&lang=js&"
export * from "./kependudukan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports